var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"loader",staticClass:"loader"},[_c('video',{staticClass:"loader__image",attrs:{"playsinline":"","autoplay":"","loop":"","muted":""},domProps:{"muted":true},on:{"canplay":_vm.setCarga}},[_c('source',{attrs:{"src":_vm.requireAsset('Loader.webm'),"type":"video/webm"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }